export const projeler = {
  title: 'Projeler',
  titleEN: 'Projects',
  description: 'Webtekno.com’da yayınlanan liste ve quiz içeriklerinden farklı olarak, teknik, tasarım ve content ekiplerinin çalışması sonucu oluşturulan, temel amacı marka ve kampanya bilinirliği arttırmak olan kullanıcı etkileşimli kurgulardır.',
  descriptionEN: 'Unlike the content and quizzes published on Webtekno.com, which are different from the list and quiz content, the projects created by the technical, design, and content teams are interactive campaigns that aim to increase brand and campaign visibility.',
  tabs: [
    {
      id: 1,
      title: 'Content Interaction Projects',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/8a9667b3c11cfc5be60b761a86ead34a8cba7d6e98b3cae83596cca9526a1ba4.png',
          url: 'https://www.figma.com/proto/7bHaFOyyWBVza5r6SHZDgJ/Akbank-Gen%C3%A7lik---Micropage?page-id=762%3A534&type=design&node-id=762-2344&viewport=691%2C388%2C0.08&t=dIZHPm12iPTMMuhJ-1&scaling=scale-down-width&starting-point-node-id=762%3A2344&show-proto-sidebar=1&mode=design',
          category: 'Akbank Gençlik - Micropage'
        },
        // {
        //   id: 2,
        //   name: '',
        //   image: 'https://srv-cdn.onedio.com/store/fb4e61b3f4acb581dfeb395d645c93ab7529f6f82be9ea186f5fc7491be63829.png',
        //   url: '',
        //   category: 'Penti - Slider Liste'
        // },
        {
          id: 2,
          // name: 'Penti - Slider Liste',
          image: 'https://srv-cdn.onedio.com/store/fb4e61b3f4acb581dfeb395d645c93ab7529f6f82be9ea186f5fc7491be63829.png',
          modal: 'image',
          modalTitle: 'Penti - Slider Liste'
        }
      ]
    },
    {
      id: 2,
      title: 'Rich Media',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/d73e23d2c22a2927f5ac26aae857e4e1b7e74a6f2d22e0cf069758c229fbba88.png',
          url: 'https://www.figma.com/proto/VEVcUFGclkL0qW036fE5Xm/Dr.-Oetker-Pizza-Masthead?page-id=460%3A18585&type=design&node-id=460-22164&viewport=1080%2C-700%2C0.12&t=IQwUiqZjMRtbv0kn-1&scaling=scale-down-width&starting-point-node-id=460%3A22164&show-proto-sidebar=1&mode=design',
          category: 'Dr.Oetker - Pizza Masthead'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/b37688dc3a9142856a5f111a22b061c20f3a97e3f770c7f6f8a345de71d0ef4d.png',
          url: 'https://www.webtekno.com/?google_preview=7k4TCIDvgZcY0svAugYw0uf1wQaIAYCAgJDAuuSaCA&iu=21814681&gdfp_req=1&lineItemId=6706015399&creativeId=138471839477',
          category: 'Karaca DUO - Takeover'
        }
      ]
    },
    {
      id: 3,
      title: 'Technology Based Special Projects',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/223345f18f2fa50266b896251c5d67551fb012661d9a53e2f263e521130de75c.png',
          url: 'https://www.figma.com/proto/fO3lQkXzXmyVAtFsq9wDHn/T%C4%B0B---Ramazan?page-id=343%3A277&type=design&node-id=343-1141&viewport=755%2C600%2C1&t=wMd2ymw1muvLWLkB-1&scaling=scale-down-width&starting-point-node-id=343%3A1141&mode=design',
          category: 'TİB - Second Screen'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/437b68d60f9f5e9249220c3419b7812d4011df338cf94267225753a53458152e.png',
          url: 'https://www.figma.com/proto/lhdkWLUKRU3I4B4qs82OjI/Volvo-Charge-Webtekno?page-id=1%3A2&type=design&node-id=2-95&viewport=154%2C88%2C0.74&t=JTxZxuJPWNIC8q8w-1&scaling=scale-down-width&mode=design',
          category: 'Volvo Charge - Takeover'
        }
      ]
    }
  ],
  egTabs: [
    {
      id: 1,
      title: 'Content Interaction Projects',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/8a9667b3c11cfc5be60b761a86ead34a8cba7d6e98b3cae83596cca9526a1ba4.png',
          url: 'https://www.figma.com/proto/7bHaFOyyWBVza5r6SHZDgJ/Akbank-Gen%C3%A7lik---Micropage?page-id=762%3A534&type=design&node-id=762-2344&viewport=691%2C388%2C0.08&t=dIZHPm12iPTMMuhJ-1&scaling=scale-down-width&starting-point-node-id=762%3A2344&show-proto-sidebar=1&mode=design',
          category: 'Akbank Gençlik - Micropage'
        },
        // {
        //   id: 2,
        //   name: '',
        //   image: 'https://srv-cdn.onedio.com/store/fb4e61b3f4acb581dfeb395d645c93ab7529f6f82be9ea186f5fc7491be63829.png',
        //   url: '',
        //   category: 'Penti - Slider Liste'
        // },
        {
          id: 2,
          // name: 'Penti - Slider Liste',
          image: 'https://srv-cdn.onedio.com/store/fb4e61b3f4acb581dfeb395d645c93ab7529f6f82be9ea186f5fc7491be63829.png',
          modal: 'image',
          modalTitle: 'Penti - Slider Liste'
        }
      ]
    },
    {
      id: 2,
      title: 'Rich Media',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/d73e23d2c22a2927f5ac26aae857e4e1b7e74a6f2d22e0cf069758c229fbba88.png',
          url: 'https://www.figma.com/proto/VEVcUFGclkL0qW036fE5Xm/Dr.-Oetker-Pizza-Masthead?page-id=460%3A18585&type=design&node-id=460-22164&viewport=1080%2C-700%2C0.12&t=IQwUiqZjMRtbv0kn-1&scaling=scale-down-width&starting-point-node-id=460%3A22164&show-proto-sidebar=1&mode=design',
          category: 'Dr.Oetker - Pizza Masthead'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/b37688dc3a9142856a5f111a22b061c20f3a97e3f770c7f6f8a345de71d0ef4d.png',
          url: 'https://www.webtekno.com/?google_preview=7k4TCIDvgZcY0svAugYw0uf1wQaIAYCAgJDAuuSaCA&iu=21814681&gdfp_req=1&lineItemId=6706015399&creativeId=138471839477',
          category: 'Karaca DUO - Takeover'
        }
      ]
    },
    {
      id: 3,
      title: 'Technology Based Special Projects',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/223345f18f2fa50266b896251c5d67551fb012661d9a53e2f263e521130de75c.png',
          url: 'https://www.figma.com/proto/fO3lQkXzXmyVAtFsq9wDHn/T%C4%B0B---Ramazan?page-id=343%3A277&type=design&node-id=343-1141&viewport=755%2C600%2C1&t=wMd2ymw1muvLWLkB-1&scaling=scale-down-width&starting-point-node-id=343%3A1141&mode=design',
          category: 'TİB - Second Screen'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/437b68d60f9f5e9249220c3419b7812d4011df338cf94267225753a53458152e.png',
          url: 'https://www.figma.com/proto/lhdkWLUKRU3I4B4qs82OjI/Volvo-Charge-Webtekno?page-id=1%3A2&type=design&node-id=2-95&viewport=154%2C88%2C0.74&t=JTxZxuJPWNIC8q8w-1&scaling=scale-down-width&mode=design',
          category: 'Volvo Charge - Takeover'
        }
      ]
    }
  ]
}
